import { createSlice } from '@reduxjs/toolkit'
import { getClaims, saveClaim, createClaim, deleteClaim } from './claimActions'

const initialState = {
  claims: [],
  loading: false,
  error: false,
  loaded: false,
  saving: false,
  saved: false,
  savedClaim: {},
  deleting: false,
  deleted: false,
}

const claimsSlice = createSlice({
  name: 'claims',
  initialState,
  reducers: {
    clear: (state) => {
      state.loading = false
      state.loaded = false

      state.saving = false
      state.error = false
      state.saved = false
      state.savedClaim = {}

      state.deleting = false
      state.deleted = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getClaims.fulfilled, (state, { payload }) => {
        state.loading = false
        state.loaded = true
        state.error = null
        state.claims = payload
      })
      .addCase(getClaims.pending, (state) => {
        state.loading = true
        state.loaded = false
        state.error = null
      })
      .addCase(getClaims.rejected, (state, { payload }) => {
        state.loading = false
        state.loaded = false
        state.error = payload
      })
      .addCase(saveClaim.pending, (state) => {
        state.saving = true
        state.error = null
        state.saved = false
      })
      .addCase(saveClaim.fulfilled, (state, { payload }) => {
        state.error = null
        state.savedClaim = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveClaim.rejected, (state, { payload }) => {
        state.saving = false
        state.error = payload
        state.saved = false
      })
      .addCase(createClaim.pending, (state) => {
        state.saving = true
        state.error = null
        state.saved = false
      })
      .addCase(createClaim.fulfilled, (state, { payload }) => {
        state.error = null
        state.savedClaim = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createClaim.rejected, (state, { payload }) => {
        state.saving = false
        state.error = payload
        state.saved = false
      })
      .addCase(deleteClaim.pending, (state) => {
        state.deleting = true
        state.error = null
        state.deleted = false
      })
      .addCase(deleteClaim.fulfilled, (state) => {
        state.error = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteClaim.rejected, (state, { payload }) => {
        state.deleting = false
        state.error = payload
        state.deleted = false
      })
  },
})

export const { clear } = claimsSlice.actions
export default claimsSlice.reducer
